import React from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import metalHero from "./img/metal1.webp";
import { ensureNamespace } from "../../i18n/ensurePageI18n";

const loadI18n = (i18n) => {
  ensureNamespace(i18n, 'metals', {
    en: {
      sectionTitle: "Metals",
      sectionSubtitle: "High-Performance Camera Inspection for Metal Surfaces",
      title: "METALS",
      heroDesc: "Wintriss camera inspection systems are highly effective in metal defect detection. Patented lighting technologies help reveal even the subtlest defects.",
      typicalProductsTitle: "Typical Products",
      typicalProductsContent: "Aluminum and aluminum alloy foil, copper, stainless steel foil, cobalt/cobalt alloy, nickel/nickel alloy and more.",
      typicalDefectsTitle: "Typical Defects",
      typicalDefectsContent: "Pinholes, oil stains, bumps, scratches, corrosion spots, and black spots."
    },
    zh: {
      sectionTitle: "金屬箔",
      sectionSubtitle: "高效金屬箔表面相機檢測",
      title: "金屬箔",
      heroDesc: "微覺視相機檢測系統在金屬箔缺陷偵測上相當有效，專利照明技術可揭示最微小的缺陷。",
      typicalProductsTitle: "典型產品",
      typicalProductsContent: "鋁及鋁合金箔、銅、不鏽鋼箔、鈷/鈷合金、鎳/鎳合金等。",
      typicalDefectsTitle: "常見缺陷",
      typicalDefectsContent: "針孔、油污、突起、刮傷、腐蝕斑、黑點。"
    }
  });
};

function Metals() {
  const { t, i18n } = useTranslation();
  loadI18n(i18n);

  return (
    <div>
      <section className="section-metals relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10 flex justify-between items-start">
          <div>
            <h1 className="text-5xl font-bold mb-4">{t("metals:sectionTitle")}</h1>
            <p className="text-xl text-white">{t("metals:sectionSubtitle")}</p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">{t("metals:title")}</h2>
          <p className="leading-relaxed text-sm md:text-base">{t("metals:heroDesc")}</p>
        </div>
        <div className="flex justify-center">
          <img src={metalHero} alt={t("metals:title")} className="rounded-lg shadow-lg w-full max-w-md object-cover" loading="lazy" />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-20 grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("metals:typicalProductsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("metals:typicalProductsContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("metals:typicalDefectsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("metals:typicalDefectsContent")}</p>
        </div>
      </section>
    </div>
  );
}

export default Metals;